import { render, staticRenderFns } from "./MusicCard.vue?vue&type=template&id=49520f99&scoped=true&"
import script from "./MusicCard.vue?vue&type=script&lang=ts&"
export * from "./MusicCard.vue?vue&type=script&lang=ts&"
import style0 from "./MusicCard.vue?vue&type=style&index=0&id=49520f99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49520f99",
  null
  
)

export default component.exports